<template>
  <div class="reference-popup-form" v-if="form">
    <div class="reference-popup-form__row">
      <in
        class="reference-popup-form__input"
        v-model="form.name"
        :label="$t('plugins.refs.creationDialog.form.reactionName')"
      ></in>
      <div class="reference-popup-form__sw-wrapper">
        <sw-button
          class="hourly-stats__control"
          v-model="form.useRegexp"
          :label="$t('plugins.refs.creationDialog.form.useRegexp')"
        ></sw-button>
      </div>
    </div>
    <div class="reference-popup-form__row" v-if="form.useRegexp">
      <in
        class="reference-popup-form__input"
        v-model="form.regexp.pattern"
        :label="$t('plugins.refs.creationDialog.form.regexpBody')"
      ></in>
      <div class="reference-popup-form__sw-wrapper">
        <sw-button
          class="hourly-stats__control"
          v-model="form.regexp.flags.g"
          label="g"
        ></sw-button>
        <sw-button
          class="hourly-stats__control"
          v-model="form.regexp.flags.m"
          label="m"
        ></sw-button>
        <sw-button
          class="hourly-stats__control"
          v-model="form.regexp.flags.i"
          label="i"
        ></sw-button>
      </div>
    </div>
    <div class="reference-popup-form__row" v-else>
      <in
        class="reference-popup-form__input"
        v-model="form.textMatch.pattern"
        :label="$t('plugins.refs.creationDialog.form.textMatchLabel')"
      ></in>
      <div class="reference-popup-form__sw-wrapper">
        <sw-button
          class="hourly-stats__control"
          v-model="form.textMatch.caseSensitive"
          :label="$t('plugins.refs.creationDialog.form.caseSensitive')"
        ></sw-button>
      </div>
    </div>
    <div class="reference-popup-form__row">
      <sel
        class="reference-popup-form__input"
        :label="$t('plugins.refs.creationDialog.form.target')"
        v-model="form.targetUuid"
      >
        <optgroup
          v-for="group in $store.state.flowGroups"
          :key="group.id"
          :label="group.name"
        >
          <option
            v-for="block in group.blocks"
            :key="block.id"
            :value="block.uuid"
          >
            {{ block.name }}
          </option>
        </optgroup>
      </sel>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emptyState: {
        name: "Refferal name",
        useRegexp: false,
        targetUuid: null,
        regexp: {
          pattern: "match me",
          flags: {
            g: false,
            m: false,
            i: false,
          },
        },
        textMatch: {
          pattern: "match me",
          caseSensitive: false,
        },
      },
      form: null,
    };
  },

  methods: {
    getData() {
      return this.form;
    },

    reset() {
      this.form = JSON.parse(JSON.stringify(this.emptyState));
    },

    load(d) {
      this.form = d;
    },
  },

  async created() {
    this.reset();
  },
};
</script>

<style lang="scss" scoped>
.reference-popup-form {
  width: 40vw;

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 8px;
  }

  &__input {
    width: 50%;
  }

  &__sw-wrapper {
    display: flex;
    justify-content: flex-start;
    width: 45%;

    & > * {
      margin-left: 14px;
    }
  }
}
</style>
